/* eslint-disable react/forbid-prop-types */
import React, { Suspense } from 'react'
import PropTypes from 'prop-types'
import { isOLBApp } from '../../utils/browserutils'

const OLBWrapper = React.lazy(() => import('../olbWrapper/olbWrapper'))
const StitchingLayer = ({ children }) => (
  <div
    className="stitching-layer"
    style={{ backgroundColor: 'rgb(242, 242, 245)', minHeight: '100vh' }}
  >
    {isOLBApp() ? (
      <Suspense fallback={<div>Loading...</div>}>
        <OLBWrapper>{children}</OLBWrapper>
      </Suspense>
    ) : (
      <>{children}</>
    )}
  </div>
)

StitchingLayer.propTypes = {
  children: PropTypes.PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.elementType,
    PropTypes.array,
    PropTypes.object,
    PropTypes.node
  ]).isRequired
}

export default StitchingLayer
